import React from 'react';
import { Field, reduxForm } from 'redux-form';
import constants from '../Constants';
import {fieldsAnimationClass, fieldsAnimationDelay} from '../Constants/animations';

let ConfirmForm = props => {
    const { handleSubmit } = props
    console.log(props);
    const vehicles = props.vehiclesList.map((item, index) => {
        console.log(fieldsAnimationClass);
        return (
            <div
                style={fieldsAnimationDelay}
                className={`form-check ${fieldsAnimationClass}`}
                key={index}>
                <label 
                    className="form-check-label"
                    htmlFor={item.uniqueId}>
                    <Field
                        className="form-check-input"
                        id={item.uniqueId}
                        name={item.uniqueId}
                        component="input"
                        type="checkbox" />
                        {item.year} {item.make} {item.model} 
                </label>
            </div>
        );
    });

    return (
        <form onSubmit={handleSubmit}>
            <div className="form-group">
                {vehicles}
            </div>
            <div className="app-form-actions">
            <button 
                style={fieldsAnimationDelay}                
                className={`btn btn-primary ${fieldsAnimationClass}`}
                type="submit">
                {`Confirm `}
                <i className={constants.icons.confirm} />
                </button>
                </div>
        </form>
    )
}

ConfirmForm = reduxForm({
    // a unique name for the form
    form: 'confirmForm',
    enableReinitialize: true,
    destroyOnUnmount: false
})(ConfirmForm)

export default ConfirmForm


// WEBPACK FOOTER //
// ./src/Confirm/ConfirmForm.js